import { ThemeTypes } from '../../../features/invoice-theme/theme.types';

export const DefaultInvoiceTemplate = ThemeTypes.StandardInvoiceTheme;

// Meta keys
export const ThemeMetaKey = 'theme';
export const TemplateMetaKey = 'template';
export const TitleMetaKey = 'title';
export const ClientMetaKey = 'client';
export const ProjectMetaKey = 'project';
export const InvoiceDateMetaKey = 'invoiceDate';
export const InvoicedSinceMetaKey = 'invoicedSince';
export const DueDateMetaKey = 'dueDate';
export const TmHoursMetaKey = 'tmHours';
export const TmGroupingMetaKey = 'tmGrouping';
export const ExpenditureTypeMetaKey = 'expenditureType';
export const TmHoursSinceMetaKey = 'tmHoursSince';
